import React, { useState, ChangeEvent } from 'react';
import { TextField } from '@cimpress/react-components';

interface PrecisionWrapProps {
    diameter?: number;
    width?: number;
    id?: string;
    disabled?: boolean;
    updatePrecisionWrap: (data: { id?: string; width?: number; diameter?: number }) => void;
}

const PrecisionWrap: React.FC<PrecisionWrapProps> = (props) => {
    const { id, disabled, updatePrecisionWrap } = props;

    const [validWidth, setValidWidth] = useState(props.width);
    const [validDiameter, setValidDiameter] = useState(props.diameter);
    const [width, setWidth] = useState(props.width);
    const [diameter, setDiameter] = useState(props.diameter);

    if (props.width !== validWidth || props.diameter !== validDiameter) {
        setValidWidth(props.width);
        setValidDiameter(props.diameter);
        setWidth(props.width);
        setDiameter(props.diameter);
    }

    const onChange = (e: ChangeEvent<HTMLInputElement>, prop: 'width' | 'diameter') => {
        const value = parseFloat(e.target.value);
        const data = prop === 'width' ? { width: value } : { diameter: value };
        if (prop === 'width') {
            setWidth(value);
        } else {
            setDiameter(value);
        }
        if (Number.isFinite(value)) {
            updatePrecisionWrap({ id, width, diameter, ...data });
        }
    };

    const onChangeWidth = (e: ChangeEvent<HTMLInputElement>) => onChange(e, 'width');
    const onChangeDiameter = (e: ChangeEvent<HTMLInputElement>) => onChange(e, 'diameter');

    return (
        <div className='precision-wrap'>
            <TextField
                label='Product Diameter'
                value={diameter}
                onChange={onChangeDiameter}
                type='number'
                onFocus={(e) => e.target.select()}
                disabled={disabled}
            />
            <TextField
                label='Decoration Width'
                value={width}
                onChange={onChangeWidth}
                type='number'
                onFocus={(e) => e.target.select()}
                disabled={disabled}
            />
        </div>
    );
};

export default React.memo(PrecisionWrap);
